<template>
  <article id="team" class="container">
    <h1>{{title}}</h1>
    <div v-html="content"></div>
    <section class="members">
      <Member v-for="(member, index) in members" v-bind:key="index" :member="member" />
    </section>
  </article>
</template>

<script>
// import { settings } from '../variables.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Member from '@/components/Member.vue'

export default {
  name: 'team',
  components: {
    Member
  },
  data () {
    return {
      page: {}
    }
  },
  mounted: function () {
    NProgress.done()
  },
  computed: {
    loaded () {
      return !(Object.entries(this.page).length === 0 && this.page.constructor === Object)
    },
    members () {
      return this.$store.state.teamModule.members
    },
    title () {
      return this.$store.state.teamModule.title
    },
    content () {
      return this.$store.state.teamModule.content
    }
  }
}
</script>

<style lang="scss">
  #team {
    .members {
      display: grid;
      grid-template-columns: 1fr;
      max-width: 1024px;
      margin: 0 auto;

      @media all and (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
      }
    }
  }
</style>
